export default {
    layout: {
        loading: '거래 진행 중',
        trading: '거래 진행 중'
    },
    footer: {
    },
    menu: {
        home: '홈',
        staking: '매트릭스',
        port: 'PORT',
        internet: '네트워크',
        me: '내 정보'
    },
    header: {
        selectLang: '언어 선택',
        close: '닫기',
        trading: '거래',
        dashboard: '대시보드',
        subscribeMatrix: '매트릭스 구독',
        portTaskCenter: 'PORT 작업 센터',
        network: '네트워크',
        apiBinding: 'API 연결',
        gridTree: '그리드 트리',
        account: '계정',
        documents: '문서 & 백서',
        personalCenter: '개인 센터',
        language: '언어'
    },
    home: {
        recently1:'커뮤니티',
        staticrewares: '정적',
        recentlyName: '원장',
        recentlyInfo: '수익 세부정보',
        dataUpdate: '데이터 업데이트',
        realtime: '실시간 · BSC',
        totalRevenue: '총 수익 (USDT)',
        today: '오늘',
        totalTradingVolume: '총 거래량',
        todayEarn: '오늘 수익',
        share: '친구와 공유',
        shareDesc: '수익을 보여주고 초대하여 보상 받기',
        directReferrals: '직접 추천',
        teamMembers: '팀 멤버',
        thisWeek: '이번 주',
        copy: '복사',
        recently: '최근 수익',
        netIncome: '순수익',
        dailyAverage: '일일 평균',
        quantitativeIncome: '정량 수익',
        recommend: '추천',
        port: 'PORT',
        bonus: '보너스',
        all: '전체',
        todayTitle: '오늘',
        loadingMore: '더 불러오기',
        recommendBonus: '추천 보너스',
        portTaskPassed: 'PORT 작업 완료',
        myProfit: '내 이익',
        earningOnBitDeep: 'BitDeep에서 수익 중',
        totalRevenueUsdt: '총 수익 · USDT',
        consecutiveDays: '연속 일수',
        scanToJoin: '참여하려면 스캔',
        uid: 'UID',
        referralBonus: '추천 보너스',
        shareTo: '공유하기',
        eachReferral: '공유 보상',
        screenshotAndShare: '스크린샷 후 공유',
        saveShareEarn: '저장 · 공유 · 수익',
        period: '기간',
        netProfit: '순이익',
        quantReward: '정량 보상',
        dailyBonus: 'PORT 일일 보너스',
        close: '닫기',
        permission: '권한',
        onlyEnable: '활성화만',
        enterBitgetUid: 'BITGET UID 입력',
        slogan: '슬로건',
        document: '문서',
        days: '일',
        taskText: '작업',
        minutes: '분',
        decentralizedPortTech: '탈중앙화 PoRT 기술 아키텍처, BGB 토큰 경제, 이중 인센티브 매트릭스.',
        auditReport: '감사 보고서',
        faqSupport: 'FAQ & 지원',
        telegram: 'Telegram',
        piece: '부분',
        faq: 'FAQ',
        faq1: 'Bitget API는 어떻게 연결하나요?',
        faq1Desc: 'Bitget 거래소 → 설정 → API 관리에서 API Key와 Secret을 발급받으세요. 권한은 현물 거래만 체크하고 출금 권한은 절대 체크하지 마세요. 키를 BitDeep DApp에 붙여넣은 후 1 USDT 테스트 거래를 완료하면 활성화됩니다.',
        faq2: 'PoRT(실거래 증명)는 무엇인가요?',
        faq2Desc: 'PoRT는 "거래가 곧 마이닝"의 핵심 메커니즘입니다. 시스템은 매일 Bitget API를 통해 지정 종목(예: BGB)에 대해 빠른 매수·매도를 자동으로 수행하며, 거래량이 스테이킹 금액×50% 기준을 넘으면 검증 후 당일 수익이 발생합니다.',
        faq3: '매일 수동으로 모니터링해야 하나요?',
        faq3Desc: '필요 없습니다. API 연결 후 시스템이 24시간 윈도우 내에 거래 태스크를 자동으로 완료합니다. 수동 조작이 필요 없으며, PoRT 메뉴에서 확인할 수 있습니다.',
        faq4: 'ALPHA와 SIGMA의 차이점은 무엇인가요?',
        faq4Desc: 'ALPHA(스타터): 500 USDT 스테이킹, 일일 수익 0.3-1.3%, 1세트만 구매 가능. SIGMA(프로): 1,000 USDT 스테이킹, 일일 수익 0.6-1.6%, 최대 5세트까지 구매 가능.',
        faq5: '제 자금은 안전한가요? 플랫폼이 제 자금을 만질 수 있나요?',
        faq5Desc: '자금은 100% 본인의 Bitget 계정에 그대로 보관됩니다. API는 읽기와 현물 거래 권한만 부여하며, 시스템은 어떠한 원금도 출금하거나 이체할 수 없습니다.',
        faq6: '일일 수익은 언제 정산되나요?',
        faq6Desc: 'PoRT 검증이 통과되면 다음 날 정산됩니다. 시스템이 USDT 수익과 10x Deep 포인트의 2중 보상을 자동으로 지급합니다.',
        faq7: '스카우트 보상(직접 추천 보상)은 어떻게 계산되나요?',
        faq7Desc: '직접 추천한 활성 계정 1개당 매일 고정 보상을 받습니다: ALPHA(500 USDT) 추천 시 1 USDT/일, SIGMA(1,000 USDT) 추천 시 2 USDT/일, 해당 계정의 주기가 끝날 때까지 지급됩니다.',
        faq8: '레벨(D1-D7)은 어떻게 올리나요?',
        faq8Desc: '마이너 라인(약한 쪽) 총 매출액 기준으로 승급됩니다. 예: D1은 2,000 USDT, D3은 15,000 USDT, 최고 등급 D7은 3,000,000 USDT가 필요합니다. 등급이 높을수록 레벨 차익 보상이 풍성해집니다 (D7 최대 7 USDT/인/일).',
        faq9: '한 주기는 며칠인가요? 만료 후 어떻게 되나요?',
        faq9Desc: '한 주기는 28일입니다. 주기 종료 후 스테이킹을 계속할지 선택할 수 있으며, 보상은 매일의 실제 PoRT 검증 결과에 따라 변동 지급됩니다.',
        faq10: '출금 수수료가 있나요?',
        faq10Desc:'출금 수수료는 0입니다. 플랫폼은 출금 수수료를 풀에 환원해 LP 유동성을 강화하고 선순환을 만듭니다.',
        bigArea: '큰 영역',
        smallArea: '작은 영역',
        enterWithdrawAmount: '출금 금액 입력',
        all: '전체',
        available: '사용 가능',
        totalAmount: '총 금액',
        confirmWithdraw: '출금 확인',
        withdrawRecord: '출금 기록',
        withdrawn: '출금 완료',
        quickStartGuide:'빠른 시작 가이드',
        whitepaperGuide:'백서 & 가이드',
        whitepaper:'백서 ',
        downloadPdf:'다운로드'
    },
    staking: {
        selectPackage: '매트릭스 구독',
        alpha: 'ALPHA',
        beginner: '초보자',
        sigma: 'SIGMA',
        professional: '전문가',
        popular: '가장 인기',
        dailyReturn: '작업 보상',
        teamDepth: '팀 깊이',
        limitPurchase: '구매 제한',
        layer: '계층',
        copy: '부분',
        autoRenew: '자동 갱신',
        autoReinvest: '자동 갱신 마진',
        subscribeAlpha: 'Alpha 구독',
        subscribeSigma: 'Sigma 구독',
        stakedAmount: '증거금',
        stakedAmount2: '기간',
        stakedAmount3: '누적 수익',
        stakingTime: '참여 시간',
        maturityTime: '만기 시간',
        redeem: '상환',
        renew: '갱신',
        autoRenewActive: '자동 갱신 활성',
        autoRenewInactive: '자동 갱신 비활성',
        smartContract: '스마트 계약 관리, 증거금 28일 동안 잠기며 만기 시 해제됩니다.',
        alter2:'서약 기간이 만료되었다면 갱신해 주세요.',
    },
    me: {
        account: '계정',
        my: '내 정보',
        staked: '참여 완료',
        staked1:'증거금',
        points: '포인트',
        consecutive: '연속 일수',
        withdraw: '출금',
        language: '언어',
        simplifiedChinese: '중국어 간체',
        disconnectWallet: '지갑 연결 해제',
        level: '레벨',
        joinDate: '가입일',
        bdId: 'BD-ID'
    },
    bindapi: {
        apiBinding: 'API 연결',
        bindDesc: '거래소 API 키를 연결하여 정량 거래 허용',
        apiKey: 'API 키',
        apiSecret: 'API 비밀키',
        exchange: '거래소',
        futures: '선물',
        spot: '스팟',
        readOnly: '읽기 전용',
        bind: '연결',
        riskNote: 'API 키는 거래 데이터 동기화에만 사용되며 민감한 정보는 저장되지 않습니다',
        apiConnection: 'API 연결',
        bindExchangeApi: '거래소 API 연결',
        bitDeepRead: 'BitDeep은 CEX 계정의 주문 흐름을 읽어 실제 거래 증거(PoRT)를 검증합니다.',
        noWithdraw: '출금에는 절대 관여하지 않습니다.',
        securityTip: '보안 팁 · 주의 깊게 읽으세요',
        close: '닫기',
        withdraw: '출금',
        permission: '권한',
        onlyEnable: '활성화만',
        spotTrading: '스팟 거래',
        read: '읽기',
        recommendedPartner: '추천 파트너',
        zeroFee: '0% 수수료',
        activated: '활성화됨',
        classicAccount: '클래식 계정',
        unifiedAccount: '통합 계정',
        bindBitgetApi: 'Bitget API 연결',
        upcoming: '곧 출시',
        underAudit: '감사 중',
        expected: '예정'
    },
    port: {
        portTaskCenter: 'PORT 작업 센터',
        dailyTask: '일일 작업',
        verify: '검증',
        completed: '완료',
        incomplete: '미완료',
        verifyStandard: '검증 기준',
        tradingVolume: '거래량',
        today: '오늘',
        deadline: '마감일',
        reward: '보상',
        startVerify: '검증 시작',
        verifying: '검증 중',
        verified: '검증 완료',
        insufficient: '불충분',
        viewDetails: '세부정보 보기',
        taskList: '작업 목록',
        allTasks: '모든 작업',
        completedTasks: '완료됨',
        pendingTasks: '대기 중',
        proofOfRealTrading: '실제 거래 증거',
        todayTask: '오늘의 작업',
        todayStaticIncome: '오늘의 정적 수익',
        points: '포인트',
        todayWindowClosesAt: '오늘 창 닫힘 시간',
        checkTaskStatus: '작업 상태 확인',
        teamProgress: '팀 진행 상황 · 오늘',
        realtimePortCompletion: '실시간 PORT 완료',
        completedText: '완료됨',
        pendingText: '대기 중',
        realtimeApiValidationFlow: '실시간 · API · 검증 흐름',
        rewardRemark1:'Global Dividend',
        rewardRemark2:'Level-Differential Bonus',
        rewardRemark3:'Scout Bonus',
        rewardRemark4:'Task Reward',
        rewardRemark5:'PoRT Task Success',
    },
    internet: {
    network: '네트워크',
    treeBrowser: '트리 브라우저',
    searchAddress: '0x... 주소 또는 BD-ID 검색',
    totalTradingVolume: '총 거래량',
    members: '회원',
    networkStructure: '네트워크 구조',
    allLevels: '모든 레벨',
    addRemark: '메모 추가',
    enterRemark: '메모 입력',
    cancel: '취소',
    confirm: '확인',
    alert1:'Share Performance',
    alert2:'Team Performance',
    alert3:'Task Status',
},
withdraw: {
    withdraw: '출금',
    usdtAsset: 'USDT 자산',
    withdrawAmount: '출금 금액',
    availableBalance: '사용 가능한 잔액',
    fee: '수수료',
    actualArrival: '실제 도착',
    submit: '제출',
    withdrawSuccess: '출금 성공',
    withdrawFailed: '출금 실패',
    processing: '처리 중',
    completed: '완료됨',
    withdrawHistory: '출금 기록'
},
popup: {
    taskUnfinished: '작업 미완료',
    taskUnfinishedDesc: '오늘 거래 데이터가 PoRT 검증 기준에 도달하지 못했습니다',
    todayTradingVolume: '오늘 거래량',
    remaining: '남은',
    toComplete: '오늘 작업을 완료하려면',
    tradingVolumeThreshold: '',
    deadline: '작업 종료까지 남은 시간',
    tryAgain: '나중에 다시 시도',
    goTrade: '거래하기',
    taskCompleted: '작업 검증 완료',
    taskCompletedDesc: '오늘 PoRT 거래 증거가 블록체인에 성공적으로 기록되었습니다',
    rewardIssued: '보상 발급됨',
    complete: '완료됨',
    shareTitle: '공유 초대',
    shareDesc: '친구를 초대하면 양쪽 모두 보상을 받습니다',
    referralLink: '초대 링크',
    qrCode: 'QR 코드',
    copyLink: '링크 복사',
    notask:'오늘 작업 없음',
    notaskDesc:'현재 처리 대기 중인 PoRT 거래 작업이 없습니다',
}
}